import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(_callee);

/*
Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
import { take, put, select, call } from 'redux-saga/effects';
import * as actions from '../actions';
import network from '../../../network/network';
import { clearFieldErrors, applyFieldChanges } from '../../fields/actions';
import { workingStart, workingEnd } from '../../working/actions';
import { startInterdiction } from '../../interdiction/actions';
import { getForm, getFormFields } from '../../selectors';
import { removeFormatting } from '../../../form/formatting';
import transformMessages from './support/transform-messages';
import transformFieldMessages from './support/transform-field-messages';
export default function _callee() {
  var _loop;

  return regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
            var _yield$take, payload, formId, onSuccess, onFailure, _yield$select, action, transform, postData, _postOptions, onSubmitSuccess, onSubmitFailure, postOptions, fields, fieldTransform, formTransform, response, messages, FailureMessageBean, InterdictionViewBean, globalMessages, fieldMessages, transformedGlobalMessages, transformedFieldMessages;

            return regeneratorRuntime.wrap(function _loop$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return take(actions.FORM_SUBMIT);

                  case 2:
                    _yield$take = _context.sent;
                    payload = _yield$take.payload;
                    formId = payload.formId, onSuccess = payload.onSuccess, onFailure = payload.onFailure;
                    _context.next = 7;
                    return put(clearFieldErrors({
                      formId: formId
                    }));

                  case 7:
                    _context.next = 9;
                    return put(actions.formSubmitStart({
                      formId: formId
                    }));

                  case 9:
                    _context.next = 11;
                    return put(workingStart());

                  case 11:
                    _context.next = 13;
                    return select(getForm, formId);

                  case 13:
                    _yield$select = _context.sent;
                    action = _yield$select.action;
                    transform = _yield$select.transform;
                    postData = _yield$select.postData;
                    _postOptions = _yield$select.postOptions;
                    onSubmitSuccess = _yield$select.onSubmitSuccess;
                    onSubmitFailure = _yield$select.onSubmitFailure;
                    postOptions = _postOptions.toJS ? _postOptions.toJS() : _postOptions;
                    _context.next = 23;
                    return select(getFormFields, formId);

                  case 23:
                    fields = _context.sent;
                    // Apply field-level transforms
                    fieldTransform = fields.map(function (field) {
                      return field.merge({
                        value: field.transform ? field.transform({
                          value: field.value,
                          fields: fields
                        }) : field.value
                      });
                    }).filter(function (_ref) {
                      var value = _ref.value;
                      return typeof value !== 'undefined' && value !== null;
                    }).reduce(function (payload, field) {
                      var cleanedValue = removeFormatting(field.dataType, field.value);

                      if (payload[field.name]) {
                        if (!Array.isArray(payload[field.name])) {
                          payload[field.name] = [payload[field.name]];
                        }

                        payload[field.name].push(cleanedValue);
                      } else {
                        payload[field.name] = cleanedValue;
                      }

                      return payload;
                    }, {}); // Apply form-level transforms

                    formTransform = transform ? transform({
                      action: action,
                      payload: fieldTransform
                    }) : fieldTransform;
                    _context.prev = 26;
                    _context.next = 29;
                    return network().post(Object.assign({}, postOptions, {
                      url: action,
                      data: formTransform,
                      postData: postData
                    }));

                  case 29:
                    response = _context.sent;
                    messages = response.SuccessMessageBean ? transformMessages(response.SuccessMessageBean.globalMessages) : [];
                    _context.next = 33;
                    return put(actions.formSubmitEnd({
                      formId: formId,
                      messages: messages
                    }));

                  case 33:
                    _context.next = 35;
                    return put(workingEnd());

                  case 35:
                    if (!onSuccess) {
                      _context.next = 38;
                      break;
                    }

                    _context.next = 38;
                    return call(onSuccess, response);

                  case 38:
                    if (!onSubmitSuccess) {
                      _context.next = 41;
                      break;
                    }

                    _context.next = 41;
                    return call(onSubmitSuccess, response);

                  case 41:
                    _context.next = 71;
                    break;

                  case 43:
                    _context.prev = 43;
                    _context.t0 = _context["catch"](26);
                    FailureMessageBean = _context.t0.FailureMessageBean, InterdictionViewBean = _context.t0.InterdictionViewBean;

                    if (!FailureMessageBean) {
                      _context.next = 64;
                      break;
                    }

                    globalMessages = FailureMessageBean.globalMessages, fieldMessages = FailureMessageBean.fieldMessages;
                    transformedGlobalMessages = transformMessages(globalMessages);
                    transformedFieldMessages = transformFieldMessages({
                      formId: formId,
                      fields: fields,
                      messages: fieldMessages
                    });
                    _context.next = 52;
                    return put(actions.formSubmitEnd({
                      formId: formId,
                      messages: transformedGlobalMessages,
                      fieldMessages: transformFieldMessages
                    }));

                  case 52:
                    _context.next = 54;
                    return put(applyFieldChanges(transformedFieldMessages));

                  case 54:
                    _context.next = 56;
                    return put(workingEnd());

                  case 56:
                    if (!onFailure) {
                      _context.next = 59;
                      break;
                    }

                    _context.next = 59;
                    return call(onFailure, {
                      FailureMessageBean: FailureMessageBean,
                      response: _context.t0
                    });

                  case 59:
                    if (!onSubmitFailure) {
                      _context.next = 62;
                      break;
                    }

                    _context.next = 62;
                    return call(onSubmitFailure, {
                      FailureMessageBean: FailureMessageBean,
                      response: _context.t0
                    });

                  case 62:
                    _context.next = 71;
                    break;

                  case 64:
                    if (!InterdictionViewBean) {
                      _context.next = 71;
                      break;
                    }

                    _context.next = 67;
                    return put(actions.formSubmitEnd({
                      formId: formId
                    }));

                  case 67:
                    _context.next = 69;
                    return put(workingEnd());

                  case 69:
                    _context.next = 71;
                    return put(startInterdiction({
                      interdiction: InterdictionViewBean,
                      postSuccessAction: actions.FORM_SUBMIT,
                      postSuccessPayload: payload
                    }));

                  case 71:
                  case "end":
                    return _context.stop();
                }
              }
            }, _loop, null, [[26, 43]]);
          });

        case 1:
          if (!true) {
            _context2.next = 5;
            break;
          }

          return _context2.delegateYield(_loop(), "t0", 3);

        case 3:
          _context2.next = 1;
          break;

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}